import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { UserEmployeeService } from './userEmployee.service';
import { UserService } from '../user/user.service';
import { NotificationService} from 'app/shared/notification/notification.service';
import { Contact } from 'app/core/models/contact';

@Component({
	template: `
		<h3 class="title" i18n="@@create-userEmployee">Update Employee User</h3>

		<form *ngIf="form" [formGroup]="form" (ngSubmit)="update()">
			<fieldset class="fieldset" formGroupName="authUser">
				<legend class="legend" i18n="@@data-account">Account data</legend>

				<div class="field-row">
					<div class="field-row-item">
						<label class="label" for="email" i18n="@@email">Email</label>
						<input formControlName="email" type="text" autocomplete="off">
						<validator [control]="form.controls['authUser'].controls['email']"></validator>
					</div>
				</div>
			</fieldset>

			<fieldset class="fieldset">
				<legend class="legend" i18n="@@data-userEmployee">Employee User data</legend>

				<div class="field-row">
					<div class="field-row-item">
						<label class="label" for="firstName" i18n="@@firstName">First name</label>
						<input formControlName="firstName" type="text" autocomplete="off">
						<validator [control]="form.controls['firstName']"></validator>
					</div>
					<div class="field-row-item">
						<label class="label" for="lastName" i18n="@@lastName">Last name</label>
						<input formControlName="lastName" type="text" autocomplete="off">
						<validator [control]="form.controls['lastName']"></validator>
					</div>
				</div>
				<div class="field-row">
					<div class="field-row-item">
						<label class="label" for="description" i18n="@@description">Description</label>
						<textarea formControlName="description"></textarea>
					</div>
				</div>
			</fieldset>

			<fieldset class="fieldset" formGroupName="contact">
				<legend class="legend" i18n="@@data-contact">Contact data</legend>

				<div class="field-row">
					<div class="field-row-item">
						<label class="label" for="phone" i18n="@@phone">Phone</label>
						<input formControlName="phone" type="text" autocomplete="off">
						<validator [control]="form.controls['contact'].controls['phone']"></validator>
					</div>
					<div class="field-row-item">
						<label class="label" for="phone2" i18n="@@phone2">Second phone</label>
						<input formControlName="phone2" type="text" autocomplete="off">
						<validator [control]="form.controls['contact'].controls['phone2']"></validator>
					</div>
				</div>
				<div class="field-row">
					<div class="field-row-item">
						<label class="label" for="latitude" i18n="@@latitude">Latitude</label>
						<input formControlName="latitude" type="text" autocomplete="off">
						<validator [control]="form.controls['contact'].controls['latitude']"></validator>
					</div>
					<div class="field-row-item">
						<label class="label" for="longitude" i18n="@@longitude">Longitude</label>
						<input formControlName="longitude" type="text" autocomplete="off">
						<validator [control]="form.controls['contact'].controls['longitude']"></validator>
					</div>
				</div>
				<div class="field-row">
					<div class="field-row-item">
						<label class="label" for="address" i18n="@@address">Address</label>
						<textarea formControlName="address"></textarea>
					</div>
				</div>
			</fieldset>
			
			<div class="options">
				<button class="btn-text" type="submit" [disabled]="!form.valid">
					<span i18n="@@option-save">Save</span>
				</button>
			</div>
		</form>
	`
})
export class UserEmployeeUpdateComponent implements OnInit {
	form: FormGroup;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private userEmployeeService: UserEmployeeService,
		private userService: UserService,
		private notificationService: NotificationService,
	) {}

	ngOnInit() {
		this.activatedRoute.parent.params.subscribe(params => {
			this.userEmployeeService.getById(params['userEmployeeId']).subscribe(userEmployee => {
				if (!userEmployee.contact) {
					userEmployee.contact = new Contact();
				}
				this.form = this.userEmployeeService.toFormGroupUpdate(userEmployee);
			});
		});
	}

	update() {
		this.userService.getByEmail(this.form.value['authUser'].email).subscribe(user => {
			if (user && user.id !== this.form.value['id']) {
				this.notificationService.errorDuplicated();
			} else {
				this.userEmployeeService.update(this.form.value).subscribe(userEmployee => {
					this.notificationService.sucessUpdate(userEmployee.firstName + ' ' + userEmployee.lastName);
					this.router.navigate([`../`], {relativeTo: this.activatedRoute});
				}, err => this.notificationService.error(err));
			}
		}, err => this.notificationService.error(err));
	}
}
